// extracted by mini-css-extract-plugin
export default {"sendDocumentsButtonArea":"CpvoBoxPageTableArea_sendDocumentsButtonArea__U0KF1","ackuidCellArea":"CpvoBoxPageTableArea_ackuidCellArea__MxmAH"};